import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { UIPageStore } from 'stores/ui-page-store';

import { UitkToast } from 'uitk-react-toast';

export interface NotificationProps {
  uiPage?: UIPageStore;
}

@inject('uiPage')
@observer
export class Notification extends React.Component<NotificationProps> {
  public componentWillUnmount() {
    this.props.uiPage.resetNotification();
  }

  public render() {
    const { uiPage } = this.props;

    if (!uiPage || !uiPage.notifications) {
      return null;
    }

    return (
      <React.Fragment>
        {uiPage.notifications.show && <UitkToast show={uiPage.notifications.show}>{uiPage.notifications.message}</UitkToast>}
      </React.Fragment>
    );
  }
}
